export enum DealNotificationOption {
  All = 'All',
}

export enum DefaultDealName {
  NoDeal = 'no_deal',
}
